import {DynamicGraphFilters} from '@modules/graph-mathia/core/model/dynamic-graph-filters';

export const StatisticsFilters: DynamicGraphFilters = {
    always: [{
        label: 'group',
        value: null,
    }],
    hidden: []
};
